import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import BrButton from '@govbr/react-components/lib/BrButton';
import styles from './AlertaModal.module.css';

interface AlertaModalProps {
  mensagem: string;
  onClose: () => void;
}

const AlertaModal: React.FC<AlertaModalProps> = ({ mensagem, onClose }) => (
  <Dialog open onClose={onClose}>
    <DialogContent>
      <div className={styles.modalContent}>
        <div className={styles.title}>
          <i className={`fas fa-exclamation-triangle ${styles.icon}`}></i>
          <div className={styles.subModalTitle}>ATENÇÃO!</div>
        </div>
        <div className={styles.bodyContent}>{mensagem}</div>
      </div>
      <div className={styles.modalFooter}>
        <BrButton className={styles.button} onClick={onClose}>
          OK
        </BrButton>
      </div>
    </DialogContent>
  </Dialog>
);

export default AlertaModal;
